{
  "plovila": {
    "main": {
      "title": "CAMO Inspections - Aircraft"
    },
    "buttons": {
      "nazaj": "Back",
      "nazajGlavni": "Main Menu"
    },
    "table": {
      "registracija": "Registration",
      "tip": "Type",
      "vrsta": "Category",
      "podrobno": "Details",
      "s_ure": "Total Hours",
      "s_letov": "Total Flights"
    },
    "modal": {
      "vlecno": "Towing Aircraft:",
      "obracun_servis": "Flight Logging:",
      "razpolozljivo": "Visible in Availability:",
      "tip": "Type:",
      "klub": "Club:",
      "stUr": "Initial Number of Hours:",
      "stLetov": "Initial Number of Flights:",
      "stSUr": "Flight Hours:",
      "vrsta": "Aircraft Category:",
      "datumN": "Purchase Date:",
      "datumR": "Registration Date:",
      "opombaJ": "Glider Note:",
      "datumV": "Entry Date:",
      "servis": {
        "stSUr": "Current Hours:",
        "stLetov": "Current Flights:",
        "interval": "Service Interval: ",
        "datum_zServis": "Last Service Date: ",
        "opravljen_servis": "Service Performed At:",
        "naslednji_servis": "Next Service: ",
        "status": "Status: "
      }
    },
    "navs": {
      "vnos": "Entry",
      "seznam": "List",
      "modal": {
        "pregled": "Overview",
        "servisna": "Maintenance Log"
      }
    }
  }
}
